<template>
    <div class="message-form">
        <p v-if="hasCancelledProject" class="has-text-danger has-text-centered">Projektet er blevet annulleret, og der kan derfor ikke skrives beskeder.</p>

        <b-field v-else>
            <div class="columns is-vcentered">
                <div class="column">
                        <b-input v-model="message" type="textarea" name="projectMessage"
                                 placeholder="Skriv din besked her"
                                 custom-class="data-hj-whitelist"
                                 v-validate="'required'" :data-vv-as="$t('global.forms.project.message')" />
                </div>

                <div class="column is-narrow">
                    <button @click="submit" class="button is-primary" :disabled="veeErrors.any() || !message" :class="{'is-loading': isSending}">Send</button>
                </div>
            </div>
        </b-field>
    </div>
</template>

<style lang="scss" scoped>
    @import '../../../../global/styles/variables';

</style>

<script>
    import { mapGetters, mapActions } from 'vuex';

    export default {
        data() {
            return {
                message: null,
            };
        },

        computed: {
            ...mapGetters('conversations', {
                conversation: 'activeConversation',
                isSending: 'isSendingMessage',
            }),

            hasCancelledProject() {
                return this.conversation.project
                    && this.conversation.project.cancelled_at !== null;
            },
        },

        methods: {
            ...mapActions('conversations', [
                'sendMessageInConversation',
            ]),

            async submit() {
                if (!await this.$validator.validateAll()) {
                    return;
                }

                if (this.hasCancelledProject) {
                    return;
                }

                await this.sendMessageInConversation({
                    conversation: this.conversation,
                    message: this.message,
                });

                this.message = null;
            },
        },
    };
</script>



// WEBPACK FOOTER //
// src/taskflex/conversations/components/Messages/MessageForm.vue